import type { ReactElement } from "react";
interface CastListProps {
  cast: string[];
  onRemove: (index: number) => void;
}

/**
 * Cast List Component
 */
export function CastList({ cast, onRemove }: Readonly<CastListProps>): ReactElement {
  return (
    <div className="space-y-2 mt-4">
      {cast.map((member, index) => (
        <div
          key={`${member}-${index}`}
          className="flex items-center justify-between bg-black/20 border border-neutral-800/0 px-4 py-2"
        >
          <span className="text-white text-sm hover:text-lumi-accent transition-colors duration-100">{member}</span>
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="text-neutral-500 hover:text-red-400 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}
